
import React, { useState,useMemo, useEffect } from 'react';
import Container from '@material-ui/core/Container';
import Board from '@asseinfo/react-kanban'
import '@asseinfo/react-kanban/dist/styles.css'
import api from '../../services/api';
import { pode, mensagemErro } from '../../services/acesso';
import {Link, useParams, useHistory} from "react-router-dom";
import { toast  } from 'react-toastify';
import { TextField, Button } from '@material-ui/core/';
import { LinearProgress } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Autocomplete from '@material-ui/lab/Autocomplete';

const GestaoAssessor = (props) => {

    const [emAndamento,setEmAndamento] = useState([])
    const [retornoFuturo,setRetornoFuturo] = useState([])
    const [aguardandoRetorno,setAguardandoRetorno] = useState([])
    const [semInteresse,setSemInteresse] = useState([])
    const [semPerfil,setSemPerfil] = useState([])
    const [blacklist,setBlacList] = useState([])
    const [corporateName,setCorporateName] = useState("")
    const [loading, setLoading] = React.useState(true);
    const [mailings, setMailings] = React.useState([]);
    const [mailingSelected, setMailingSelected] = React.useState(true);
    const [customers, setCustomers] = React.useState([]);
    const [customersSelected, setCustomersSelect] = React.useState(true);
    const [statusSelected, setStatusSelect] = React.useState(true);
    const [cnaeInput, setCnaeInput] = React.useState("");
    const [followUpInput, setFollowUpInput] = React.useState("");
    const [assessores, setAssessores] = useState([]);
    const [assessorSelect, setAssessorSelect] = useState([]);
    const [assessorFilter, setAssessorFilter] = useState(null);
    const [cidadeFilter, setCidadeFilter] = useState("");
    const [estadoFilter, setEstadoFilter] = useState("");
    const [cidades, setCidades] = useState([]);
    const [estados, setEstados] = useState([]);

    // Gestor/master (visao_gestao) filtram por qualquer assessor.
    // Assessor logado filtra só pelo próprio nome.
    const veTodosAssessores = pode("visao_gestao");
    const idAssessorLogado = localStorage.getItem("id_assessor");
    const opcoesFiltroAssessor = veTodosAssessores
      ? assessores
      : (idAssessorLogado
          ? [{ id: Number(idAssessorLogado), name: localStorage.getItem("name") || "Meus leads" }]
          : []);

    const handleCorporateName = (value) => {
      setCorporateName(value)
    };

    const handleAssessorFilter= (value) => {
      setAssessorFilter(value)
    };

    
    const [columns,setColumns] = useState({
        columns: [
          {
            id: 8,
            title: 'Em Branco',
            cards: []
          },
          {
            id: 1,
            title: 'Em andamento',
            cards: []
          },
          {
            id: 2,
            title: 'Retorno futuro',
            cards: []
          },
          {
            id: 3,
            title: 'Aguardando retorno',
            cards: []
          },
          {
            id: 4,
            title: 'Sem interesse',
            cards: []
          },
          {
            id: 5,
            title: 'Sem perfil',
            cards: []
          },
          {
            id: 6,
            title: 'Black list',
            cards: []
          },
          {
            id: 7,
            title: 'Reunião agendada',
            cards: []
          }
        ]
      })


    const setAssessor = (mailing_leads_id,newInputValue) => {
      let valores =  [];
      console.log(newInputValue)
      let data = {
        assessor_id: newInputValue?.id,
      };
    
      api.patch("board/"+mailing_leads_id+"/vincular-assessor", data).then(() => {

      }).catch((error) => {
        if(error?.response?.data){
          toast.error(error?.response?.data.message)
        }
      });

      valores = {...assessorSelect,...{[mailing_leads_id]:newInputValue ? newInputValue : ""}}  

     
      if(!newInputValue){
        search()
      }else{
        setAssessorSelect(valores)
      }
     
    }

    useEffect(() => {
        (async () => {
            setLoading(true)
            const result = await api.get(`board`,{
              params: { 
                "id_assessor": localStorage.getItem("id_assessor"),
                "assessor_filter_id": assessorFilter?.id,
                "cidade": cidadeFilter,
                "estado": estadoFilter
              }
            });
            let data = result.data;
            setAssessorSelect(data["assessores"])
            setColumns(data)
            setLoading(false)
        })()
    },[assessorFilter, cidadeFilter, estadoFilter])

    useEffect(() => {
      (async () => {
          try {
              const result = await api.get("assessores");
              let data = result.data?.data;
              setAssessores(data);
          } catch (e) {
              const response = e.response ? e.response : {};
              const data = response.data ? response.data : {};
              const msg = data.message ? data.message : "Ocorreu um erro ao capturar os dados do mailing";
              toast.error(msg)
          }
      })();
  }, []);

    useEffect(() => {
      (async () => {
          const result = await api.get(`mailings`,{
            params: { 
              "assessor_id":  localStorage.getItem("id_assessor"),
              "customer_id":  customersSelected?.id
            }
          });
          let data = result.data.data;
          console.log(data)
          setMailings(data)
      })()
    },[customersSelected])

    useEffect(() => {
      (async () => {
        const result = await api.get("customers",{ 
          params: { 
            "assessor_id": localStorage.getItem("id_assessor")
          }
        });
        let data = result.data;
        setCustomers(data.data);
      })();
    }, []);

    useEffect(() => {
      // Lista de estados brasileiros
      const estadosBrasil = [
        { sigla: "AC", nome: "Acre" },
        { sigla: "AL", nome: "Alagoas" },
        { sigla: "AP", nome: "Amapá" },
        { sigla: "AM", nome: "Amazonas" },
        { sigla: "BA", nome: "Bahia" },
        { sigla: "CE", nome: "Ceará" },
        { sigla: "DF", nome: "Distrito Federal" },
        { sigla: "ES", nome: "Espírito Santo" },
        { sigla: "GO", nome: "Goiás" },
        { sigla: "MA", nome: "Maranhão" },
        { sigla: "MT", nome: "Mato Grosso" },
        { sigla: "MS", nome: "Mato Grosso do Sul" },
        { sigla: "MG", nome: "Minas Gerais" },
        { sigla: "PA", nome: "Pará" },
        { sigla: "PB", nome: "Paraíba" },
        { sigla: "PR", nome: "Paraná" },
        { sigla: "PE", nome: "Pernambuco" },
        { sigla: "PI", nome: "Piauí" },
        { sigla: "RJ", nome: "Rio de Janeiro" },
        { sigla: "RN", nome: "Rio Grande do Norte" },
        { sigla: "RS", nome: "Rio Grande do Sul" },
        { sigla: "RO", nome: "Rondônia" },
        { sigla: "RR", nome: "Roraima" },
        { sigla: "SC", nome: "Santa Catarina" },
        { sigla: "SP", nome: "São Paulo" },
        { sigla: "SE", nome: "Sergipe" },
        { sigla: "TO", nome: "Tocantins" }
      ];
      setEstados(estadosBrasil);
    }, []);

    const search = async() => {
      setLoading(true)
      const result = await api.get(`board`,{
        params: {
          customer_id: customersSelected?.id,
          mailing_id: mailingSelected?.id,
          corporate_name:corporateName,
          mailing_id: mailingSelected?.id,
          status: statusSelected?.status,
          cnae: cnaeInput,
          follow_up: followUpInput,
          id_assessor: localStorage.getItem("id_assessor"),
          assessor_filter_id: assessorFilter?.id,
          cidade: cidadeFilter,
          estado: estadoFilter
        }
      })

      const data = result?.data
      setColumns(data)
      setLoading(false)
    }

    function changePosition(arr, from, to) {
        arr.splice(to, 0, arr.splice(from, 1)[0]);
        return arr;
    };


  const handleMailingSelected = (value) => {
    setMailingSelected(value);
  };

    const updatePositionAndStatus = async (toColumnId, cards_positions, board, backup) => {
      try {
        let data = {
          status: toColumnId,
          positions: JSON.stringify(cards_positions)
        };
        await api.patch("board/"+board.id, data);
      } catch(e) {
        const msg = mensagemErro(e, "Sem permissão");
        toast.error(msg)
        setColumns(backup);
      }
    }

    const onCardDragEnd = async (board,card, source) => {
        const backup = JSON.parse(JSON.stringify(columns));
        let {toColumnId, toPosition} = source;
        let {fromColumnId} = card;
        let n_coluns = JSON.parse(JSON.stringify(columns));

        const posicoesDaColuna = (lista) => {
          const indexCol = lista.findIndex(f => f.id == toColumnId);
          const cards_positions = [];
          if (indexCol < 0) return cards_positions;
          lista[indexCol].cards.forEach((item, index) => {
            cards_positions.push({
              id_lead: item.id,
              position: index
            });
          });
          return cards_positions;
        };

        if(toColumnId == fromColumnId) {
          n_coluns.columns = n_coluns.columns.map(col => {
            if(col.id == toColumnId) {
              let posicao_atual = col.cards.findIndex(fin => fin.id == board.id);
              col.cards = changePosition(col.cards, posicao_atual, toPosition);
            }
            return col;
          })

          setColumns(n_coluns);
          updatePositionAndStatus(toColumnId, posicoesDaColuna(n_coluns.columns), board, backup);
          return;
        }

        n_coluns.columns = n_coluns.columns.map(col => {
          if(col.id == toColumnId) {
            col.cards.push(board);
          }
          return col;
        })

        n_coluns.columns = n_coluns.columns.map(col => {
          if(col.id == toColumnId) {
            col.cards = changePosition(col.cards, (col.cards.length - 1), toPosition);
          }
          return col;
        })

        n_coluns.columns = n_coluns.columns.map(col => {
          if(col.id == fromColumnId) {
            col.cards = col.cards.filter(cc => cc.id != board.id);
          }
          return col;
        });

        setColumns(n_coluns);
        updatePositionAndStatus(toColumnId, posicoesDaColuna(n_coluns.columns), board, backup);
    }
  


    return (
        <>
            <Container fixed>
                <div>
                    <h1> { "Gestão de Leads" } </h1>
                </div>
                <div
                  style={{
                    borderRadius: "5px",
                    borderLeftWidth: "1px",
                    borderRightWidth: "1px",
                    border: "1px solid rgba(0, 0, 0, 0.12)",
                    backgroundColor:"#fff",
                    padding:"10px"
                  }}
                >
                                     <Grid container  spacing={2}>
                     <Grid item xs={3}>
                       <Autocomplete
                             disablePortal
                             id="Cliente"
                             options={customers}
                             onChange={(event, newInputValue) => {
                               setCustomersSelect(newInputValue);
                             }}
                             value={customersSelected}
                             getOptionLabel={(option) => option.name || ""}
                             sx={{ width: 300 }}
                             renderInput={(params) => <TextField {...params} label="Cliente" />}
                         />
                     </Grid>
                     <Grid item xs={3}>
                       <Autocomplete
                           disablePortal
                           id="Mailing"
                           options={mailings}
                           onChange={(event, newInputValue) => {
                               handleMailingSelected(newInputValue);
                           }}
                           value={mailingSelected}
                           getOptionLabel={(option) => option.name || ""}
                           sx={{ width: 300 }}
                           renderInput={(params) => <TextField {...params} label="Mailing" />}
                       />

                     </Grid>
                     <Grid item xs={3}>
                         <TextField  
                           style={{marginLeft: "5px"}}
                           id="corporate_name"
                           label="Razão Social"
                           InputLabelProps={{
                             shrink: true,
                           }}
                           value={corporateName} 
                           type={"text"}
                           onChange={
                             evt => handleCorporateName(evt.target.value)
                           } fullWidth/>
                       </Grid>
                     {(veTodosAssessores || idAssessorLogado) && (
                     <Grid item xs={3}>
                       <Autocomplete
                           disablePortal
                           id="Assessor"
                           options={opcoesFiltroAssessor}
                           onChange={(event, newInputValue) => {
                             handleAssessorFilter(newInputValue);
                           }}
                           InputLabelProps={{
                             shrink: true,
                           }}
                           value={assessorFilter}
                           getOptionLabel={(option) => option.name || ""}
                           getOptionSelected={(option, valor) => String(option.id) === String(valor?.id)}
                           sx={{ width: 300 }}
                           renderInput={(params) => <TextField {...params} label="Assessor" />}
                       />
                     </Grid>
                     )}
                   </Grid>
                   <Grid container spacing={2} style={{marginTop: "15px"}}>
                     <Grid item xs={3}>
                       <Autocomplete
                           disablePortal
                           id="Estado"
                           options={estados}
                           onChange={(event, newInputValue) => {
                               setEstadoFilter(newInputValue?.sigla || "");
                           }}
                           value={estados.find(estado => estado.sigla === estadoFilter) || null}
                           getOptionLabel={(option) => `${option.sigla} - ${option.nome}`}
                           sx={{ width: 300 }}
                           renderInput={(params) => <TextField {...params} label="Estado" />}
                       />
                     </Grid>
                     <Grid item xs={3}>
                       <TextField  
                           style={{marginLeft: "5px"}}
                           id="cidade"
                           label="Cidade"
                           InputLabelProps={{
                             shrink: true,
                           }}
                           value={cidadeFilter} 
                           type={"text"}
                           onChange={
                             evt => setCidadeFilter(evt.target.value)
                           } fullWidth/>
                       </Grid>
                     <Grid item xs={3}>
                         <TextField  
                           style={{marginLeft: "5px"}}
                           id="follow_up"
                           label="Follow Up"
                           InputLabelProps={{
                             shrink: true,
                           }}
                           value={followUpInput} 
                           type={"date"}
                           onChange={
                             evt => setFollowUpInput(evt.target.value)
                           } fullWidth/>
                       </Grid>
                   </Grid>
                  <Grid container style={{marginTop:"15px"}}  spacing={2}>
                    <Grid item xs={6}>
                      <Button 
                      variant="contained" 
                      style={{color:"#4B8B33"}} 
                      onClick={() => { search() }}
                      href="#contained-buttons"
                      >
                        PESQUISAR
                      </Button>
                      {pode("editar_leads") && (
                      <Link to="/leads/novo" style={{ textDecoration: 'inherit', marginLeft: "5px"}}>
                          <Button variant="contained" style={{color:"#4B8B33"}} href="#contained-buttons">
                              NOVO LEAD
                          </Button>
                      </Link>
                      )}
                    </Grid>
                  </Grid>  
                </div>
                <br /><br />
                {loading && <div style={{width: "100%"}}>
                  <LinearProgress/>
                </div>}  

                                  
                <Board 
                    key={"board"}
                    children={columns} 
                    disableCardDrag={!pode("editar_leads")}
                    onCardDragEnd={onCardDragEnd}
                    renderCard={({ title, content, id_assessor, assessor_name, lead_id, color_border, follow_up, mailing_leads_id }, { removeCard, dragging }) => (
                  
                        <div style={{backgroundColor: "#fff", borderColor: color_border, borderStyle: "solid",maxWidth:290,width:290, padding: 10, marginBottom: 10, borderRadius: 5}} dragging={dragging} >
                              <Link to={`/leads/${lead_id}/edit?mailing_leads_id=${mailing_leads_id}`} style={{ textDecoration: 'inherit'}} target="_blank">
                                  <b><p>{title}</p></b>
                                </Link>
                            {content}
                            {follow_up && <p><b>Follow-up</b>: {follow_up}</p>}
                            <div>
                            <Autocomplete
                                id={"assessor"+mailing_leads_id}
                                options={assessores}
                                disabled={!pode("editar_leads")}
                                onChange={(event, newInputValue) => {

                                  setAssessor(mailing_leads_id, newInputValue);
                                }}
                                value={id_assessor ? id_assessor : assessorSelect[mailing_leads_id]?.id}
                                inputValue={assessor_name ? assessor_name : (assessorSelect[mailing_leads_id]?.name ? assessorSelect[mailing_leads_id]?.name : "")}
                                getOptionLabel={(option) => option.name || ""}
                                sx={{ width: 300 }}
                                renderInput={(params) => <TextField {...params} label="Assessor" />}
                            />  
                            </div>
                            
                        </div>
                   
                  )}
                />
            </Container>
        </>
    )
}

export default  GestaoAssessor;